import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { getTempCouponById, getTempCouponDetailImageFile } from '../List/useModel'

const TempCouponDetail = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')

  const store = useMemo(() => getTempCouponById(id), [id])

  if (!store) {
    return (
      <div className="flex min-h-[calc(100vh-var(--spacing)*45)] flex-col items-center justify-center gap-6 bg-[#F8F6FF] px-6 py-16">
        <LangText lngKey="b98e6c99" className="text-center text-[16px] text-[#666666]">
          {t('b98e6c99')}
        </LangText>
        <Link
          to="/temp-coupon-list"
          className="text-[15px] font-medium text-[#5A5EFA] no-underline hover:opacity-80"
        >
          <LangText lngKey="6a6e9832">{t('6a6e9832')}</LangText>
        </Link>
      </div>
    )
  }

  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-[#F8F6FF] px-4 py-8 md:py-12">
      <div className="mx-auto max-w-3xl">
        <img
          src={preFixImgUrl(getTempCouponDetailImageFile(store))}
          alt=""
          className="object-contain w-full h-auto"
        />
      </div>
    </div>
  )
}

export default TempCouponDetail
